// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___NzO5","controls":"styles_controls__2xYqf","charLimit":"styles_charLimit__d8SrI","input":"styles_input__3ntIU","send":"styles_send__8EXgC"};